const BASE_URL = "/validador";

const sidebarRoutesValidador = [
  {
    path: `${BASE_URL}/nuevo-consumo`,
    name: "home-validador",
    meta: { title: "Validar", icon: "check", sidebar: true },
    component: () => import("../views/validador/home/HomeView.vue")
  },
  {
    path: `${BASE_URL}/consumo`,
    name: "order",
    meta: { title: "Historial", icon: "calendar", sidebar: true },
    component: () => import("../views/validador/order/OrderList.vue")
  }
];

export { sidebarRoutesValidador };
export default sidebarRoutesValidador.filter(r => r.path);
